const InputTypes = [
  'email',
  'password',
  'text',
];

const InputElementTypes = [
  'input',
  'textarea',
];

export { InputTypes, InputElementTypes };



// WEBPACK FOOTER //
// ./src-react/DesignSystem/TextInputs/InputTypes.jsx